import { Box, List, ListItem, Typography } from '@mui/material';
import { ContactInfoLink } from './ContactInfoLink';
import { ContactAvatar } from './ContactAvatar';

const ContactInfoMapper = ({ array, name, headline, isSubheadline, additionalSubhead, noContactInfo }) => {
	//TODO: add theme for colors or adjust existing theme
	const fontColor = '#083163';
	const accentColor = '#6983A1';
	if (!array || array.length === 0) {
		return <Box sx={{ gridArea: 'contact', margin: '1rem' }}></Box>;
	}
	return (
		<>
			<Typography sx={{
				padding: '1rem 0 0 1rem',
				fontSize: isSubheadline ? '1rem' : '1.222rem',
				fontWeight: 'medium',
				color: fontColor
			}}>{headline}</Typography>
			{additionalSubhead && <Typography sx={{ fontSize: '.75rem', color: fontColor, padding: '0 0 0 1rem' }} variant='body1'>{additionalSubhead}</Typography>}
			<List sx={{ gridArea: 'contact', padding: '0 1rem 0 0' }}>
				{array.map((person) => {
					const noPhoneInfo = (() => {
						if (!person.phoneNumber || person.phoneNumber.length === 0) {
							return true;
						}
					})();
					const noMailInfo = (() => {
						if (!person.email || person.email.length === 0) {
							return true;
						}
					})();
					return (
						<ListItem disablePadding key={person.fullName} sx={{ margin: '1rem' }}>
							<Box sx={{
								display: 'grid',
								'@container course-info (min-width: 600px) and (max-width: 960px)': {
									gridTemplateColumns: noPhoneInfo && noMailInfo
										? '.75fr minmax(max-content, 3fr)'
										: noPhoneInfo
											? '.75fr minmax(max-content, 4fr) minmax(min-content, 4fr)'
											: noMailInfo
												? '.75fr minmax(max-content, 3fr) minmax(min-content, 2fr)'
												: '.75fr minmax(max-content, 3fr) minmax(min-content, 2fr) minmax(min-content, 3fr)',
									gridTemplateRows: '1fr',
									gridTemplateAreas: `"image name ${!noPhoneInfo ? 'tel' : ''} ${!noMailInfo ? 'mail' : ''}"`,
								},
								gridTemplateColumns: '1fr 4fr',
								gridTemplateRows: noPhoneInfo || noMailInfo ? 'repeat(2, .5fr)' : 'repeat(3, .5fr)',
								gridTemplateAreas: noPhoneInfo
									? `
									"image name"
									"image mail"`
									: noMailInfo
										? `
										"image name"
										"image tel"`
										: `
										"image name"
										"image tel"
										"image mail"`
							}}>
								<Typography sx={{
									gridArea: 'name',
									alignSelf: 'center',
									justifySelf: 'start',
									color: fontColor,
									mr: '1rem'
								}}>
									{person.fullName}
								</Typography>
								<Box sx={{
									gridArea: 'image',
									alignSelf: 'center',
									justifySelf: 'start',
									mr: '1.25rem'
								}}>
									<ContactAvatar
										person={person}
										color={accentColor}
										size={'3rem'}
										tooltipText={name}
										tooltipColor={fontColor}
									/>
								</Box>
								{person.phoneNumber && noContactInfo === false &&
									<ContactInfoLink info={person.phoneNumber} color={fontColor} type='tel'
													 gridArea='tel' />}
								{person.email && noContactInfo === false &&
									<ContactInfoLink info={(person.email).toLowerCase()} color={fontColor} type='mail'
													 gridArea='mail' />}
							</Box>
						</ListItem>
					)
				})}
			</List>
		</>
	);
};

export { ContactInfoMapper };